
<div class="search-container" *ngIf="showSearch">
  <div class="input-group">
    <input class="form-control" [value]="search" [formControl]="searchControl" (keyup)="searchSubmit($event)" placeholder="Search" [ngClass]="{'with-help': hasSearchHelp}">
    <div class="position-relative">
      <button class="btn btn-primary btn-circle-sm oi oi-question-mark over-input" *ngIf="hasSearchHelp" (click)="openSearchHelp()"></button>
    </div><span class="input-group-append">
      <button class="btn btn-primary" (click)="searchSubmit($event)">Go</button></span>
  </div>
</div>
<div class="left-expando" *ngIf="!showSearch"></div>
<label class="pagination-limit control-label" *ngIf="showLimit" [ngClass]="{hasSearch: showSearch}"><span>Show:</span>
  <select class="form-control" [(ngModel)]="limit" (change)="limitChanged()">
    <option *ngFor="let size of allowedPageSizes" [value]="size">{{ size }}</option>
  </select>
</label>
<select class="pagination-limit-sm form-control" *ngIf="showLimit" [ngClass]="{hasSearch: showSearch}" [(ngModel)]="limit" (change)="limitChanged()">
  <option *ngFor="let size of allowedPageSizes" [value]="size">Show {{ size }}</option>
</select>
<ul class="pagination" [ngClass]="{hasSearch: showSearch, hasLimit: showLimit}">
  <li class="page-item" [ngClass]="{'disabled': !canPreviousPage}"><a class="page-link" (click)="previousPage()" aria-label="Previous"><span aria-hidden="true">&laquo;</span></a></li>
  <li class="page-item" *ngFor="let obj of pageList" [ngClass]="{'active': obj.active}"><a class="page-link" (click)="goToPage(obj.page)"><span>{{ obj.page }}</span></a></li>
  <li class="page-item" [ngClass]="{'disabled': !canNextPage}"><a class="page-link" (click)="nextPage()" aria-label="Next"><span aria-hidden="true">&raquo;</span></a></li>
</ul>
<select class="pagination-sm form-control" [ngClass]="{hasSearch: showSearch, hasLimit: showLimit}" [(ngModel)]="page">
  <option *ngFor="let obj of pageList" [value]="obj.page">Page {{ obj.page }}</option>
</select>
<div class="pagination-index" [ngClass]="{hasSearch: showSearch}"><span [hidden]="!zero">No results</span><span [hidden]="zero">{{ start }} to {{ finish }} of {{ totalCount }}</span></div>
<div class="ext-block">
  <ng-content></ng-content>
</div>